module.exports = __webpack_public_path__ + "img/survey-cat.5e8b4c96.png";